import {styled} from '@mui/material';

export const TableContainer = styled('div')(() => ({
  marginBottom: 40,
  '&:last-of-type': {
    marginBottom: 0,
  },
}));
